<template>
    <CDropdown
        inNav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="header-logo">
                    <img
                        src="img/cargomx-logo-cropped.png"
                        alt="CargoMX"
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>{{$t('account')}}</strong>
        </CDropdownHeader>
        <CDropdownItem href="/profile" v-if="isAuth">
            <CIcon name="cil-user" /> {{$t('profile')}}
        </CDropdownItem>
        <CDropdownItem href="/login" v-if="isAuth">
            <CIcon name="cil-lock-locked" /> {{$t('logout')}}
        </CDropdownItem>
        <CDropdownItem href="/login" v-if="!isAuth">
            <CIcon name="cil-user" /> {{$t('login.label')}}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
export default {
    name: 'TheHeaderDropdownAccnt',
    computed: {
        isAuth() {
            return localStorage.getItem('login') === 'true';
        }
    }
}
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}

.header-logo {
    align-items: center;
    display: flex;
    height: 72px;
}

.header-logo img {
    height: 66px;
    max-width: 150px;
    object-fit: contain;
}
</style>
